import * as Api from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { Settings, SettingsAction } from "../types/settings";

function getSettingsRequest(): SettingsAction {
  return {
    type: ActionType.GET_SETTINGS_REQUEST,
  };
}

function getSettingsSuccess(settings: Settings): SettingsAction {
  return {
    type: ActionType.GET_SETTINGS_SUCCESS,
    settings,
  };
}

function getSettingsFailure(error: any): SettingsAction {
  return {
    type: ActionType.GET_SETTINGS_FAILURE,
    error,
  };
}

export function getSettings(): ThunkAction<
  void,
  State,
  unknown,
  SettingsAction
> {
  return async (dispatch, getState) => {
    const { network } = getState();

    if (!network.fetching.settings) {
      dispatch(getSettingsRequest());
      try {
        const settings = await Api.getSettings();

        dispatch(getSettingsSuccess(settings));
      } catch (error) {
        dispatch(getSettingsFailure(error));
      }
    }
  };
}
